<template>
    <Container>
        <div class="container-content visual-container" :class="props.reversed ? 'reversed' : ''">
            <div>
                <slot></slot>
            </div>
            <slot name="video"></slot>
            <slot name="img"></slot>
            <slot name="media"></slot>
        </div>
    </Container>
</template>

<script setup>
const props = defineProps({
    reversed: {
        type: Boolean,
        default: false
    }
});
</script>

<style lang="scss">
@use "./index.scss";
</style>
